module.exports = import("https://esm.sh/@tiptap/extension-document@2.4.0");;